import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/content";
import { errorText } from "@/lib/errors";
import { Reveal } from "./Reveal";

const field = "mt-2 block w-full bg-transparent border-b border-mist/40 py-2 text-base text-sage normal-case tracking-normal placeholder:text-mist/50 focus:outline-none focus:border-brass-light transition-colors";
const EMPTY = { name: "", email: "", request: "" };

export const Prayer = () => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/prayer-requests`, { name: form.name || null, email: form.email || null, request: form.request });
      setSent(true);
      setForm(EMPTY);
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="prayer" className="bg-pine text-sage py-24 md:py-32 scroll-mt-20" data-testid="prayer-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_1.2fr] gap-12">
        <Reveal className="min-w-0">
          <h2 className="dp">Send a <em>prayer request</em></h2>
          <p className="mt-4 text-mist max-w-md">Only Don & Lorrie read these. Your name and email are optional, so you can stay anonymous.</p>
        </Reveal>
        <Reveal delay={120}>
          {sent ? (
            <div className="rounded-2xl bg-pine-soft p-8" data-testid="prayer-success">
              <p className="dp text-3xl">We're praying with you.</p>
              <p className="mt-3 text-mist">Your request reached Don & Lorrie privately.</p>
              <button type="button" onClick={() => setSent(false)} className="mt-6 underline underline-offset-4 decoration-brass-light" data-testid="prayer-send-another">Send another request</button>
            </div>
          ) : (
            <form onSubmit={submit} className="grid gap-6" data-testid="prayer-form">
              <label className="lb text-mist">Your prayer request<textarea required rows="4" value={form.request} onChange={set("request")} className={field} data-testid="prayer-request-input" /></label>
              <div className="grid sm:grid-cols-2 gap-6">
                <label className="lb text-mist">Name (optional)<input value={form.name} onChange={set("name")} className={field} data-testid="prayer-name-input" /></label>
                <label className="lb text-mist">Email (optional)<input type="email" value={form.email} onChange={set("email")} className={field} data-testid="prayer-email-input" /></label>
              </div>
              <button type="submit" disabled={sending} className="justify-self-start rounded-full bg-sage text-pine px-8 py-4 transition-colors hover:bg-white disabled:opacity-70" data-testid="prayer-submit-button">
                {sending ? "Sending..." : "Send privately"}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
};
